<template>
  <div class="container my-3">
    <h1 class="fw-bold text-warning">
      <router-link to="/" class="text-decoration-none">
        <fa :icon="['fa', 'chevron-left']" class="fs-6 me-2" /> </router-link
      >Devis
    </h1>
    <!-- Titre de la page -->
    <h1>Renseignements sur un projet de terrassement</h1>
    <p class="text-muted" v-if="!showSteps">
      Besoin d’un conteneur sur-mesure pour votre projet ? Que vous soyez
      particulier ou entreprise, faites votre choix et laissez-vous guider pas à
      pas. À chaque étape, nous sommes là pour vous proposer l'offre qui
      correspond à vos besoins. Simplifiez votre réservation dès maintenant !
    </p>

    <!-- Choix entre Particulier et Entreprise -->
    <div class="container my-4" v-if="!showSteps">
      <div class="row gap-2">
        <div
          class="card col-12 col-lg-3"
          :class="{
            'border border-warning active': selectedType === 'particulier'
          }"
          @click="selectType('particulier')"
        >
          <div class="card-body d-flex">
            <div class="d-flex flex-row flex-grow-1">
              <div class="flex-column align-content-center flex-grow-1">
                <span
                  >Je suis un
                  <span class="fw-bold text-selected">particulier</span></span
                >
                <p class="mb-0 text-selected">Pour les besoins individuels.</p>
              </div>
              <fa :icon="['fa', 'user']" class="ms-4 card-icon" />
            </div>
          </div>
        </div>
        <div
          class="card col-12 col-lg-3"
          :class="{
            'border border-warning active': selectedType === 'entreprise'
          }"
          @click="selectType('entreprise')"
        >
          <div class="card-body d-flex">
            <div class="d-flex flex-row flex-grow-1">
              <div class="flex-column align-content-center flex-grow-1">
                <span
                  >Je suis un
                  <span class="fw-bold text-selected">professionnel</span></span
                >
                <p class="mb-0 text-selected">Pour les projets d'entreprise.</p>
              </div>

              <fa :icon="['fa', 'building']" class="ms-4 card-icon" />
            </div>
          </div>
        </div>
      </div>
      <!--- <div class="row">
        <div class="col-12 p-0">
          <button class="btn btn-primary mt-3" @click="setShowSteps(true)">
            Réserver
          </button>
        </div>
      </div> -->
    </div>

    <!-- Stepper -->
    <div v-if="showSteps">
      <div class="modern-stepper">
        <button
          v-if="currentStep === 1"
          class="btn btn-outline-danger mt-3 mb-3 me-3 border-0"
          @click="setShowSteps(false)"
        >
          <fa :icon="['fa', 'rotate-right']" />
        </button>

        <button
          v-if="currentStep > 1"
          class="btn btn-outline-warning mt-3 mb-3 me-3 border-0"
          @click="previousStep"
        >
          <fa :icon="['fa', 'chevron-left']" />
        </button>
        <div class="progress-info">
          <div class="progress-container">
            <svg
              class="progress-circle"
              viewBox="0 0 36 36"
              xmlns="http://www.w3.org/2000/svg"
            >
              <!-- Cercle de fond (non rempli) -->
              <circle
                class="progress-circle-bg"
                cx="18"
                cy="18"
                r="15.915"
                stroke="#6c757d"
                stroke-width="3"
                fill="none"
              />
              <!-- Cercle de progression (rempli selon le pourcentage) -->
              <circle
                class="progress-circle-fg"
                cx="18"
                cy="18"
                r="15.915"
                stroke="#f0b800"
                stroke-width="3"
                fill="none"
                :stroke-dasharray="circumference"
                :stroke-dashoffset="strokeDashoffset"
              />
            </svg>
            <div class="step-circle">{{ currentStep }} of {{ totalSteps }}</div>
          </div>
        </div>
        <ul class="stepper stepper-container d-flex flex-md-row mb-3">
          <li :class="{ active: currentStep === 1 }">
            <div class="stepper-text">
              <div class="step-title">Type de Conteneur</div>
              <p>Choisissez votre conteneur.</p>
            </div>
          </li>
          <li :class="{ active: currentStep === 2 }">
            <div class="stepper-text">
              <div class="step-title">Volume de Conteneur</div>
              <p>Sélectionner le volume.</p>
            </div>
          </li>
          <li :class="{ active: currentStep === 3 }">
            <div class="stepper-text">
              <div class="step-title">Date de Livraison</div>
              <p>Indiquez la date souhaitée.</p>
            </div>
          </li>
          <li :class="{ active: currentStep === 4 }">
            <div class="stepper-text">
              <div class="step-title">Recevez vos tarifs</div>
              <p>Obtenez votre offre personnalisée.</p>
            </div>
          </li>
        </ul>
      </div>
      <!-- Barre de progression -->
      <!-- <div class="progress mb-4">
      <div
        class="progress-bar"
        role="progressbar"
        :style="{ width: `${(currentStep - 1) * 25}%` }"
        aria-valuenow="25"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div> -->

      <!-- Formulaire avec les étapes -->
      <div v-if="currentStep === 1">
        <div class="row">
          <div
            class="col-12 col-md-3 col-lg-3"
            v-for="(container, index) in getContainerOptions"
            :key="index"
            @click="selectContainer(container)"
            :class="{ selected: selectedContainer === container }"
          >
            <div class="card mb-4 pb-2">
              <div class="card-body pb-0">
                <div class="container-plus-icon">
                  <img
                    src="@/assets/smallcontainer_yellow.svg"
                    class="img-icon"
                  />
                  <fa :icon="['fa', 'circle-plus']" />
                  <div class="img-materiaux" :class="container.class"></div>
                </div>
                <p class="large-text text-center mt-2 mb-2">
                  {{ container.label }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-6 col-lg-6 d-flex">
            <button
              class="btn btn-outline-secondary mt-3"
              @click="setShowSteps(false)"
            >
              <fa :icon="['fa', 'chevron-left']" />
            </button>
          </div>
          <div class="col-6 col-lg-6 d-flex justify-content-end">
            <button
              class="btn btn-outline-primary mt-3"
              @click="nextStep"
              :disabled="!selectedContainer"
            >
              <fa :icon="['fa', 'chevron-right']" />
            </button>
          </div> 
        </div> -->
      </div>

      <div v-if="currentStep === 2">
        <div class="row gap-2">
          <div
            class="col-12 col-lg-3"
            v-for="(volume, index) in getVolumeOptions"
            :key="index"
            @click="selectVolume(volume)"
            :class="{ selected: selectedVolume === volume }"
          >
            <div class="card w-100 h-100">
              <div class="card-body text-center p-2">
                <p class="large-text">{{ volume }} m³</p>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-6 col-lg-6 d-flex"></div>
          <div class="col-6 col-lg-6 d-flex justify-content-end">
            <button
              class="btn btn-outline-primary mt-3"
              @click="nextStep"
              :disabled="!selectedVolume"
            >
              <fa :icon="['fa', 'chevron-right']" />
            </button>
          </div>
        </div> -->
      </div>

      <div v-if="currentStep === 3">
        <div class="row">
          <div class="col-6 col-lg-3">
            <VueDatePicker
              v-model="deliveryDate"
              v-if="isDarkMode"
              inline
              auto-apply
              dark
              @update:modelValue="nextStep"
            />
            <VueDatePicker
              v-model="deliveryDate"
              v-if="!isDarkMode"
              inline
              auto-apply
              @update:modelValue="nextStep"
            />
          </div>
          <div class="col-6 col-lg-9"></div>
        </div>
        <!-- <div class="row">
          <div class="col-6 col-lg-3 d-flex">
            <button
              class="btn btn-outline-secondary mt-3"
              @click="previousStep"
            >
              <fa :icon="['fa', 'chevron-left']" />
            </button>
          </div>
          <div class="col-6 col-lg-3 d-flex justify-content-end">
            <button
              class="btn btn-outline-primary mt-3"
              @click="nextStep"
              :disabled="!deliveryDate"
            >
              <fa :icon="['fa', 'chevron-right']" />
            </button>
          </div>
        </div> -->
      </div>

      <div v-if="currentStep === 4">
        <form @submit.prevent="submitForm">
          <div class="row">
            <div class="col-6 col-lg-3 mb-3">
              <input
                v-model="form.lastName"
                type="text"
                class="form-control"
                placeholder="Nom"
                required
              />
            </div>
            <div class="col-6 col-lg-3 mb-3">
              <input
                v-model="form.firstName"
                type="text"
                class="form-control"
                placeholder="Prénom"
                required
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6 mb-3">
              <input
                v-model="form.phone"
                type="tel"
                class="form-control"
                placeholder="Téléphone"
                required
                pattern="^(\+?\d{1,3}[- ]?)?\d{10}$"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6 mb-3">
              <input
                v-model="form.email"
                type="email"
                class="form-control"
                placeholder="Adresse email"
                required
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6 col-lg-3 mb-3">
              <input
                v-model="form.postalCode"
                type="text"
                class="form-control"
                placeholder="Code postal"
                required
                pattern="\d{4,5}"
              />
            </div>
          </div>
          <div class="row">
            <div class="mb-3 col-12 col-lg-6">
              <textarea
                v-model="form.address"
                class="form-control"
                rows="3"
                placeholder="Adresse de livraison"
                required
              ></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-6 col-lg-3 d-flex"></div>
            <div class="col-6 col-lg-3 d-flex justify-content-end">
              <button type="submit" class="btn btn-primary">
                <fa :icon="['fa', 'paper-plane']" class="me-2" />
                Envoyer
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Notification -->
    <div v-if="notification" class="alert alert-success mt-3" role="alert">
      Nous traitons votre demande.
    </div>
  </div>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

export default {
  components: {
    VueDatePicker // Ajoutez-le ici
  },
  props: {
    isDarkMode: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      currentStep: 1,
      totalSteps: 4,
      selectedType: null,
      selectedContainer: null,
      selectedVolume: null,
      showSteps: false,
      deliveryDate: '',
      form: {
        lastName: '',
        firstName: '',
        phone: '',
        email: '',
        postalCode: '',
        address: ''
      },
      notification: false,
      containerOptions: [
        { label: 'Bois', class: 'img-wood' },
        { label: 'Bricaillon', class: 'img-bricaillons' },
        { label: 'Bricaillon & Fine +50%', class: 'img-bricaillons-gros' },
        { label: 'Bricaillon & Fine -50%', class: 'img-bricaillons-fins' },
        { label: 'Carton', class: 'img-carton' },
        { label: 'Dechet vert', class: 'img-dechet-vert' },
        { label: 'Mitraille', class: 'img-mitraille' },
        { label: 'Terre', class: 'img-terre' },
        { label: 'Tout venant', class: 'img-tout-venant' },
        { label: 'Verre', class: 'img-verre' }
      ],
      volumeOptions: ['8', '10', '12', '15', '20', '25', '30', '40']
    }
  },
  computed: {
    minDate() {
      const today = new Date()
      today.setDate(today.getDate()) // Assurez-vous que la date minimale est la date actuelle
      return today.toISOString().split('T')[0] // Date au format yyyy-mm-dd
    },
    getContainerOptions() {
      return this.containerOptions
    },
    getVolumeOptions() {
      return this.volumeOptions
    },
    progressPercentage() {
      return (this.currentStep / this.totalSteps) * 100
    },
    circumference() {
      return 2 * Math.PI * 15.915 // Circonférence du cercle, basée sur le rayon
    },
    // Calcul du dashoffset en fonction du pourcentage
    strokeDashoffset() {
      const progress = this.progressPercentage / 100
      return this.circumference - progress * this.circumference // Valeur pour "remplir" le cercle
    }
  },
  methods: {
    selectType(type) {
      this.selectedType = type
      this.selectedContainer = null // Reset container selection when type changes
      this.selectedVolume = null // Reset volume selection when type changes
      this.currentStep = 1 // Reset to first step
      this.setShowSteps(true)
    },
    goToStep(step) {
      this.currentStep = step
    },
    nextStep() {
      if (this.currentStep < 4) {
        this.currentStep++
      }
    },
    previousStep() {
      if (this.currentStep > 1) {
        this.currentStep--
      }
    },
    setShowSteps(switchOn) {
      this.showSteps = switchOn
    },
    selectContainer(container) {
      this.selectedContainer = container
      this.nextStep()
    },
    selectVolume(volume) {
      this.selectedVolume = volume
      this.nextStep()
    },
    submitForm() {
      // Simuler l'envoi du formulaire
      this.notification = true
      setTimeout(() => {
        this.notification = false
        this.resetForm()
      }, 5000)
    },
    resetForm() {
      this.currentStep = 1
      this.selectedType = null
      this.selectedContainer = null
      this.selectedVolume = null
      this.deliveryDate = ''
      this.form = {
        lastName: '',
        firstName: '',
        phone: '',
        email: '',
        postalCode: '',
        address: ''
      }
    }
  }
}
</script>

<style scoped>
.modern-stepper {
  display: flex;
  margin-bottom: 1rem;
}

.stepper-container {
  justify-content: space-between;
  align-items: center;
  /* Pour l'alignement horizontal */
}

.stepper {
  list-style: none;
  padding: 0;
  margin-bottom: 2rem;
}

.stepper li {
  display: inline-block;
  text-align: center;
  width: 25%;
  position: relative;
  cursor: pointer;
  transition: color 0.3s ease;
}

.stepper li:not(.active) {
  display: none;
}

.stepper li.active {
  width: 100%;
  display: flex;
}

.stepper-text {
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.step-title {
  font-size: 16px;
  font-weight: bold;
  color: #f0b800;
}

.stepper .step-number {
  color: #fff;
}

.stepper li:not(.active) {
  color: #ccc;
}

.stepper li span {
  display: inline-block;
  background-color: #ccc;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin-bottom: 10px;
  transition: background-color 0.3s ease;
}

.stepper li.active span {
  background-color: #f0b800;
}

.card {
  cursor: pointer;
  transition: border 0.3s ease;
}

.card.selected {
  border: 2px solid #f0b800;
}

.progress-container {
  position: relative;
  width: 120px;
  /* Taille du cercle */
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-circle {
  transform: rotate(-90deg);
  /* Pour commencer la progression à partir du haut du cercle */
  width: 100%;
  height: 100%;
  position: absolute;
}

.step-circle {
  font-weight: bold;
}

.progress-circle-bg {
  opacity: 0.2;
  /* Couleur du fond (cercle non rempli) */
}

.progress-circle-fg {
  transition: stroke-dashoffset 0.3s ease;
  /* Animation pour remplir le cercle */
}

.progress {
  height: 20px;
  background-color: #e0e0e0;
  border-radius: 5px;
}

.progress-bar {
  background-color: #f0b800;
}

.card-icon {
  font-size: 40px;
  color: #6c757d;
  /* Gris par défaut */
  margin-top: 10px;
  transition: color 0.3s ease;
  /* Animation de la couleur de l'icône */
}

.card.active {
  color: #f0b800;
}

.card.active .card-icon {
  color: #f0b800;
  /* Jaune lorsque la carte est active */
}

.card.active .text-selected {
  color: #f0b800;
  /* Jaune lorsque la carte est active */
}

.selected .card-body {
  border: 2px solid #f0b800;
}

.card-body {
  font-size: 1rem;
  border-radius: 0.5rem;
  border: 2px solid transparent;
}

.large-text {
  font-size: 0.85rem;
  font-weight: bold;
}

.container-plus-icon {
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
}

.container-plus-icon .fa-circle-plus {
  color: #f7c600;
  margin-right: 0.5rem;
}

.container-plus-icon img {
  width: 80px;
  margin-right: 0.5rem;
}

.img-materiaux {
  width: 64px;
  height: 64px;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  display: flex;
  align-self: center;
}

.img-wood {
  background-image: url('@/assets/materiaux/wood.png');
}

.img-bricaillons-fins {
  background-image: url('@/assets/materiaux/bricaillons_fins.png');
}

.img-bricaillons-gros {
  background-image: url('@/assets/materiaux/bricaillons_gros.png');
}

.img-bricaillons {
  background-image: url('@/assets/materiaux/bricaillons.png');
}

.img-carton {
  background-image: url('@/assets/materiaux/carton.png');
}

.img-dechet-vert {
  background-image: url('@/assets/materiaux/dechet_vert.png');
}

.img-mitraille {
  background-image: url('@/assets/materiaux/mitraille.png');
}

.img-terre {
  background-image: url('@/assets/materiaux/terre.png');
}

.img-verre {
  background-image: url('@/assets/materiaux/verre.png');
}

.img-tout-venant {
  background-image: url('@/assets/materiaux/tout_venant.png');
}
</style>
